// Oh Happy Co. – Cart & UX enhancements
(function () {

  /* ========== FREE SHIPPING BAR ========== */
  var FREE_THRESHOLD = 6000; // €60 in cents

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function isEnglish() {
    return (document.documentElement.lang || 'nl').startsWith('en');
  }

  function buildBar(cartTotal) {
    var remaining = FREE_THRESHOLD - cartTotal;
    var pct = Math.min(100, Math.round((cartTotal / FREE_THRESHOLD) * 100));
    var en = isEnglish();
    var msg = remaining > 0
      ? (en
          ? 'Add <strong>' + money(remaining) + '</strong> more for <strong>free shipping in NL</strong>'
          : 'Voeg nog <strong>' + money(remaining) + '</strong> toe voor <strong>gratis verzending in NL</strong>')
      : (en ? 'Free shipping unlocked!' : 'Gratis verzending ontgrendeld!');
    var color = remaining > 0 ? '#555' : '#284777';
    var fw = remaining > 0 ? 'normal' : '600';
    return '<div id="ohh-free-shipping-bar" style="padding:12px 16px;background:#F8F2E7;border-radius:10px;margin:12px 16px;">'
      + '<p style="font-size:13px;color:' + color + ';font-weight:' + fw + ';text-align:center;margin:0 0 8px 0;line-height:1.4;">'
      + msg + '</p>'
      + '<div style="background:#F4D6DD;border-radius:20px;height:5px;overflow:hidden;">'
      + '<div style="height:100%;border-radius:20px;background:#284777;width:' + pct + '%;transition:width 0.4s ease;"></div>'
      + '</div></div>';
  }

  function injectOrUpdate(cartTotal) {
    var existing = document.getElementById('ohh-free-shipping-bar');
    if (existing) {
      var tmp = document.createElement('div');
      tmp.innerHTML = buildBar(cartTotal);
      existing.replaceWith(tmp.firstChild);
      return;
    }
    var target = document.querySelector('.cart-drawer__footer, .drawer__footer');
    if (!target) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = buildBar(cartTotal);
    target.parentNode.insertBefore(tmp.firstChild, target);
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { injectOrUpdate(cart.total_price); })
      .catch(function () {});
  }

  document.addEventListener('cart-drawer:after-open', refresh);
  document.addEventListener('cart-drawer:open', refresh);
  document.addEventListener('cart:refresh', refresh);

  function observeDrawer() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'aria-hidden') {
          if (m.target.getAttribute('aria-hidden') === 'false') {
            setTimeout(refresh, 50);
          }
        }
        if (m.attributeName === 'class') {
          var cl = m.target.classList;
          if (cl.contains('active') || !cl.contains('is-empty')) {
            setTimeout(refresh, 50);
          }
        }
      });
    });
    obs.observe(drawerEl, { attributes: true });
    var inner = document.getElementById('CartDrawer');
    if (inner) {
      obs.observe(inner, { attributes: true });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[href*="cart"], [aria-controls*="Cart"], .cart-icon-bubble, [data-cart-open], .js-drawer-open-cart');
    if (trigger) setTimeout(refresh, 300);
  });

  document.addEventListener('DOMContentLoaded', function () {
    observeDrawer();
    refresh();
  });

  /* ========== EXIT INTENT POPUP ========== */
  (function () {
    var POPUP_KEY = 'ohh_exit_shown';
    if (sessionStorage.getItem(POPUP_KEY)) return;

    var en = (document.documentElement.lang || 'nl').startsWith('en');
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var CODE = 'WELCOME10';

    var logoEl = document.querySelector('.header__heading-logo img, .header__heading img, .header__logo img');
    var logoHTML = logoEl
      ? '<div class="ohh-exit-popup__logo" style="text-align:center;margin-bottom:8px;"><img src="' + logoEl.src + '" alt="Oh Happy Co." style="height:44px;width:auto;display:inline-block;"></div>'
      : '';

    var popupHTML = '<div id="ohh-exit-popup" role="dialog" aria-modal="true">'
      + '<div class="ohh-exit-popup__box">'
      + '<button class="ohh-exit-popup__close" id="ohh-exit-close" aria-label="Close">&times;</button>'
      + logoHTML
      + '<h2 class="ohh-exit-popup__heading">' + (en ? 'Wait — a little gift for you!' : 'Wacht even — een cadeautje voor jou!') + '</h2>'
      + '<p class="ohh-exit-popup__sub">' + (en
          ? 'Get <strong>10% off</strong> your first order. Enter your email and your code appears right here.'
          : 'Ontvang <strong>10% korting</strong> op je eerste bestelling. Vul je e-mail in en je code verschijnt meteen.') + '</p>'
      + '<form class="ohh-exit-popup__form" id="ohh-exit-form" method="post" action="' + ROOT + 'contact#ohh-exit-form" accept-charset="UTF-8">'
      + '<input type="hidden" name="form_type" value="customer">'
      + '<input type="hidden" name="utf8" value="✓">'
      + '<input type="hidden" name="contact[tags]" value="newsletter,exit-popup">'
      + '<input class="ohh-exit-popup__input" type="email" name="contact[email]" autocomplete="email" placeholder="' + (en ? 'Your email address' : 'Jouw e-mailadres') + '" required>'
      + '<button class="ohh-exit-popup__btn" type="submit">' + (en ? 'Get 10% off' : 'Ontvang 10% korting') + '</button>'
      + '</form>'
      + '<p class="ohh-exit-popup__note">' + (en ? 'No spam, unsubscribe anytime.' : 'Geen spam, altijd opzegbaar.') + '</p>'
      + '</div></div>';

    document.body.insertAdjacentHTML('beforeend', popupHTML);

    var popup = document.getElementById('ohh-exit-popup');

    function showPopup() {
      if (sessionStorage.getItem(POPUP_KEY)) return;
      popup.classList.add('is-visible');
      sessionStorage.setItem(POPUP_KEY, '1');
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
    }

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 5) showPopup();
    });

    window.addEventListener('pagehide', showPopup);

    document.getElementById('ohh-exit-close').addEventListener('click', hidePopup);
    popup.addEventListener('click', function (e) {
      if (e.target === popup) hidePopup();
    });

    function showCode(email) {
      var box = document.querySelector('.ohh-exit-popup__box');
      box.innerHTML = '<h2 class="ohh-exit-popup__heading">' + (en ? 'Here\'s your 10% off' : 'Hier is je 10% korting') + '</h2>'
        + '<p class="ohh-exit-popup__sub">' + (en ? 'Use this code at checkout:' : 'Gebruik deze code bij het afrekenen:') + '</p>'
        + '<p style="margin:12px auto 4px;padding:12px 16px;border:1.5px dashed #284777;border-radius:10px;font-size:22px;font-weight:700;letter-spacing:2px;color:#284777;background:#F8F2E7;max-width:240px;">' + CODE + '</p>'
        + '<p class="ohh-exit-popup__note">' + (en ? 'Already applied to your cart. One use per customer.' : 'Al toegepast op je winkelwagen. Eenmalig per klant.') + '</p>'
        + '<button class="ohh-exit-popup__btn" id="ohh-exit-continue" style="margin-top:16px;">'
        + (en ? 'Continue shopping' : 'Verder winkelen') + '</button>';
      var btn = document.getElementById('ohh-exit-continue');
      if (btn) btn.addEventListener('click', hidePopup);
    }

    document.getElementById('ohh-exit-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var form = this;
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      var email = form.querySelector('input[type="email"]').value;
      // Subscribe the email as a Shopify customer with email marketing consent (Customers > tag "exit-popup")
      fetch(form.action.split('#')[0], {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      })
        .then(function (r) {
          // Shopify sometimes asks for a captcha: fall back to a normal form submit so the visitor can complete it
          if (!r.ok || /\/challenge/.test(r.url)) { form.submit(); return; }
          // Apply the code to this visitor's cart/checkout automatically
          fetch(ROOT + 'discount/' + CODE, { credentials: 'same-origin' }).catch(function () {});
          showCode(email);
        })
        .catch(function () { form.submit(); });
    });

    // After a captcha round-trip Shopify returns to /?customer_posted=true#ohh-exit-form: show the code
    if (/customer_posted=true/.test(location.search) && location.hash === '#ohh-exit-form') {
      fetch(ROOT + 'discount/' + CODE, { credentials: 'same-origin' }).catch(function () {});
      popup.classList.add('is-visible');
      showCode('');
    }

    var inactivityTimer;
    function resetTimer() {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(showPopup, 45000);
    }
    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, resetTimer, { passive: true });
    });
    resetTimer();
  })();

})();

// Oh Happy Co. – Minimum order quantity
// Products with metafield custom.minimum_quantity (e.g. 10) can only be checked out
// once the cart holds at least that many of the product (all variants added up).
// Data comes from templates/cart.ohh-min.liquid (/cart?view=ohh-min).
(function () {
  var items = [];
  var loaded = false;

  function en() {
    return (document.documentElement.lang || 'nl').startsWith('en');
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function violations() {
    return items.filter(function (i) { return i.total < i.min; });
  }

  function cartTotalFor(productId) {
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].product_id) === String(productId)) return items[i].total;
    }
    return 0;
  }

  function warningText(v) {
    var missing = v.min - v.total;
    return en()
      ? '<strong>' + v.title + '</strong>: minimum order is ' + v.min + ' boxes (designs can be mixed). You have ' + v.total + ' — add ' + missing + ' more to check out.'
      : '<strong>' + v.title + '</strong>: minimale bestelling is ' + v.min + ' dozen (designs mogen gemengd). Je hebt er ' + v.total + ' — voeg er nog ' + missing + ' toe om af te rekenen.';
  }

  /* ---- Product page ---- */
  function productRule() {
    var el = document.querySelector('[data-ohh-min-product]');
    if (!el) return null;
    var min = parseInt(el.getAttribute('data-ohh-min'), 10) || 0;
    if (min < 2) return null;
    var needed = Math.max(min - cartTotalFor(el.getAttribute('data-ohh-min-product')), 1);
    return { min: min, needed: needed };
  }

  function quantityInputs() {
    return document.querySelectorAll('.product-form__quantity .quantity__input');
  }

  function applyProductPage() {
    var rule = productRule();
    if (!rule) return;
    quantityInputs().forEach(function (input) {
      if (String(input.min) !== String(rule.needed)) input.min = rule.needed;
      if ((parseInt(input.value, 10) || 0) < rule.needed) input.value = rule.needed;
    });
  }

  function showProductNote(rule) {
    var input = quantityInputs()[0];
    if (!input) return;
    var box = input.closest('.product-form__quantity');
    if (!box) return;
    var note = box.querySelector('.ohh-min-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'ohh-min-note';
      note.setAttribute('role', 'alert');
      note.style.cssText = 'margin:8px 0 0;font-size:0.85rem;color:#8a1f1f;';
      box.appendChild(note);
    }
    note.textContent = en()
      ? 'Minimum order is ' + rule.min + ' boxes — add at least ' + rule.needed + ' to continue.'
      : 'Minimale bestelling is ' + rule.min + ' dozen — voeg er minstens ' + rule.needed + ' toe om verder te gaan.';
  }

  function productQtyTooLow() {
    var rule = productRule();
    if (!rule) return null;
    var input = quantityInputs()[0];
    var qty = input ? (parseInt(input.value, 10) || 0) : 1;
    return qty < rule.needed ? rule : null;
  }

  function blockIfTooLow(e) {
    var rule = productQtyTooLow();
    if (!rule) return false;
    e.preventDefault();
    e.stopImmediatePropagation();
    applyProductPage();
    showProductNote(rule);
    return true;
  }

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) blockIfTooLow(e);
  }, true);

  // "Buy it now" / express buttons on the product page
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-form .shopify-payment-button')) blockIfTooLow(e);
  }, true);

  // Typing a number lower than allowed
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.product-form__quantity .quantity__input')) return;
    var rule = productRule();
    if (rule && (parseInt(input.value, 10) || 0) < rule.needed) input.value = rule.needed;
  }, true);

  /* ---- Cart page + cart drawer ---- */
  function applyCart() {
    var list = violations();
    var blocked = list.length > 0;
    var html = list.map(warningText).join('<br>');

    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      var has = prev && prev.classList.contains('ohh-min-warning');
      if (!blocked) {
        if (has) prev.remove();
        return;
      }
      if (has && prev.getAttribute('data-html') === html) return;
      if (has) prev.remove();
      var box = document.createElement('p');
      box.className = 'ohh-min-warning';
      box.setAttribute('role', 'alert');
      box.setAttribute('data-html', html);
      box.style.cssText = 'margin:12px 0;padding:12px 14px;background:#fff4f4;border:1px solid #f0caca;border-radius:10px;font-size:0.85rem;line-height:1.5;color:#8a1f1f;text-align:left;';
      box.innerHTML = html;
      ctas.parentNode.insertBefore(box, ctas);
    });

    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      if (blocked && !btn.disabled) {
        btn.disabled = true;
        btn.setAttribute('data-ohh-min-disabled', '');
      } else if (!blocked && btn.hasAttribute('data-ohh-min-disabled')) {
        btn.disabled = false;
        btn.removeAttribute('data-ohh-min-disabled');
      }
    });

    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (el) {
      var want = blocked ? 'none' : '';
      if (el.style.display !== want) el.style.display = want;
    });
  }

  // Safety net: block checkout submit while a minimum is not met
  document.addEventListener('submit', function (e) {
    if (violations().length && e.submitter && e.submitter.name === 'checkout') {
      e.preventDefault();
      e.stopImmediatePropagation();
      applyCart();
    }
  }, true);

  function apply() {
    if (!loaded) return;
    applyCart();
    applyProductPage();
  }

  var pending = null;
  function load() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch(root() + 'cart?view=ohh-min', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          items = (JSON.parse(t).items) || [];
          loaded = true;
          apply();
        })
        .catch(function () {});
    }, 150);
  }

  function init() {
    load();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, load);
    }
    document.addEventListener('cart:refresh', load);
    // The theme re-renders the cart drawer / cart page after changes: re-apply (idempotent)
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; apply(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
